import { createHead } from '@unhead/vue/client';
import type { App } from 'vue';

export function vueUseHeadInit(app: App) {
  const head = createHead();
  app.use(head);
}
